<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="flex flex-col">
          <div class="mb-6 relative">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center">
              <button
                type="button"
                class="inline-flex items-center shadow-sm px-3 py-1 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <span>SMS Receipts</span>
              </button>
            </div>
          </div>

          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
            >
              <div
                class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Description
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Created At
                      </th>
                    </tr>
                  </thead>

                  <div
                    v-if="showLoading"
                    wire:loading
                    class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
                  >
                    <div
                      class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"
                    ></div>
                    <h2 class="text-center text-white text-xl font-semibold">
                      Loading...
                    </h2>
                    <p class="w-1/3 text-center text-white">
                      This may take a few seconds, please don't close this page.
                    </p>
                  </div>

                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="message in messages" :key="message.id">
                      <td class="px-6 py-4 whitespace-nowrap flex">
                        <div class="flex-shrink-0 h-10 w-10 mr-4">
                          <a href="#" @click="redirect(message)">
                            <img
                              class="h-10 w-10 rounded-full"
                              :src="url + message.message_name + rest"
                              alt=""
                            />
                          </a>
                        </div>

                        <div class="text-sm text-gray-500">
                          {{ message.message_body | shortText(50) }}

                          <div v-if="message.repeats.length > 0">
                            <span
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-900"
                            >
                              multiple deliveries
                            </span>
                          </div>
                          <div v-else>
                            <span
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                            >
                              Single delivery
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <a
                          v-if="message.tags.length > 0"
                          @click="openTags(message.tags)"
                          class="cursor-pointer text-indigo-600 hover:text-indigo-900"
                          >Check Deliver status</a
                        >
                      </td>
                      <!-- <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ formatDate(message.create_at) }}
                      </td> -->

                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        <template
                          type="button"
                          class="inline-flex items-center shadow-sm px-2 py-0.5 text-xs leading-5 font-medium rounded-full text-gray-50 bg-indigo-600 hover:bg-indigo-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          <span>{{ formatDate(message.created_at) }}</span>
                        </template>
                      </td>
                    </tr>

                    <!-- More items... -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isTag">
          <div
            class=" flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
          >
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
              class="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
              >&#8203;</span
            >

            <div
              class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <h3
                  class="text-lg leading-6 font-medium text-gray-900"
                  id="modal-headline"
                >
                  Tags
                </h3>
                <div class="mt-2">
                  <!-- This example requires Tailwind CSS v2.0+ -->
                  <div class="flex flex-col">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div
                        class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                      >
                        <div
                          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                        >
                          <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                              <tr>
                                <th
                                  scope="col"
                                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  Tag Name
                                </th>

                                <th
                                  scope="col"
                                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  Users in this Tag
                                </th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr v-for="tag in tags" :key="tag.id">
                                <td class="px-6 py-4 whitespace-nowrap">
                                  <div class="flex items-center">
                                    <div class="flex-shrink-0 h-10 w-10">
                                      <img
                                        class="h-10 w-10 rounded-full"
                                        :src="url + tag.name + rest"
                                        alt=""
                                      />
                                    </div>
                                    <div class="ml-4">
                                      <div class="text-sm text-gray-500">
                                        {{ tag.name }}
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <div
                                  v-for="member in tag.users"
                                  :key="member.id"
                                >
                                  <td class="px-6 py-4">
                                    <span
                                      class="mt-1 px-2 inline-flex text-xs leading-5 font-light rounded-full bg-gray-100 text-gray-800"
                                    >
                                      {{ member.email }}
                                    </span>
                                  </td>

                                  <td class="px-6 py-4" v-if="member.reciepts">
                                    <small>Status:</small>
                                    <span
                                      v-if="
                                        member.reciepts.status == 'Delivered'
                                      "
                                      class="ml-2 mt-1 px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800"
                                    >
                                      {{ member.reciepts.status }}
                                    </span>
                                    <span
                                      v-if="member.reciepts.status == 'Failed'"
                                      class="font-medium ml-2 mt-1 px-2 inline-flex text-xs leading-5 rounded-full bg-red-100 text-red-800"
                                    >
                                      {{ member.reciepts.status }}
                                    </span>
                                  </td>
                                </div>
                              </tr>

                              <!-- More items... -->
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                  >
                    <!-- <button
                          type="submit"
                          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        >
                          Save
                        </button> -->
                    <button
                      @click="closeTag()"
                      type="button"
                      class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- close Modal -->
      </div>
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      messages: [],
      responseMessage: "",

      selected: "",
      isOpen: false,
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc",

      tags: "",
      isTag: false,

      isOpenUsers: false,

      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc",
      showLoading: true
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  created() {
    this.getMessages();
  },

  methods: {
    // chatUser(id) {
    //   window.axios.get("/api/smsmsg/" + id).then(response => {
    //     alert(response.data);
    //   });
    // },

    formatDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },

    redirect(message) {
      this.$router.push({ name: "CrmMessage", params: { id: message.id } });
    },

    getMessages() {
      window.axios.get("/api/message_sms").then(response => {
        this.messages = response.data;
        this.showLoading = false;
      });
    },

    openTags(tags) {
      this.tags = tags;
      this.isTag = true;
      //$("#userUp").modal("show");
    },

    closeModal() {
      this.isOpen = false;
      this.selected = "";
    },

    closeTag() {
      this.isTag = false;
      this.tags = "";
    },

    openRecipients(item) {
      this.selected = item;
      this.isOpenUsers = true;
      //$("#userUp").modal("show");
    }
  }
};
</script>
